import React from 'react';

import { Box, DropdownMenu, IconButton } from '@betterment/samba-react';

import { HouseholdAccountsQuery } from './graphql/query.householdAccounts.generated';

import urlBuilder from '../../../Shared/url-builder';
import { ImpersonationLink } from '../ImpersonationLink';

type HouseholdData = Extract<HouseholdAccountsQuery['household'], { __typename: 'Household' }>;
type Envelope = HouseholdData['accounts'][number]['envelope'];

export const EnvelopeRowMenu: React.FC<{
  envelope: Envelope;
}> = ({ envelope }) => {
  const { user, purpose } = envelope;

  if (!purpose) {
    return null;
  }

  const { legacyGoalId } = purpose;

  return (
    <Box onClick={e => e.stopPropagation()}>
      <DropdownMenu>
        <DropdownMenu.Trigger asChild={true}>
          <IconButton label="Show options" name="Ellipses" variant="solidSecondary" spacing="compact" />
        </DropdownMenu.Trigger>
        <DropdownMenu.Content align="end" side="bottom" css={{ minWidth: '200px' }}>
          <DropdownMenu.Item>
            <ImpersonationLink
              showModal={false}
              url={urlBuilder.getImpersonateClientPage.absolute({
                clientId: user.id,
                deep_link_path: `/app/purpose/${purpose.id}`,
              })}
              label="Go to goal"
            />
          </DropdownMenu.Item>
          <DropdownMenu.Item>
            <ImpersonationLink
              showModal={false}
              url={urlBuilder.getImpersonateClientPage.absolute({
                clientId: user.id,
                deep_link_path: `/app/edit_goal_details_flows/new?goal_id=${legacyGoalId}`,
              })}
              label="Edit goal details"
            />
          </DropdownMenu.Item>
          <DropdownMenu.Item>
            <ImpersonationLink
              showModal={false}
              url={urlBuilder.getImpersonateClientPage.absolute({
                clientId: user.id,
                deep_link_path: '/app/deposit_setup/destination',
              })}
              label="Deposit"
            />
          </DropdownMenu.Item>
          <DropdownMenu.Item>
            <ImpersonationLink
              showModal={false}
              url={urlBuilder.getImpersonateClientPage.absolute({
                clientId: user.id,
                deep_link_path: '/app/withdrawal_setup',
              })}
              label="Withdrawal"
            />
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu>
    </Box>
  );
};
